import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import ExpandButton from './ExpandButton';
import { useHistoryMovementsView } from '../context/HistoryMovementsViewContext';

const DefaultTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useHistoryMovementsView();

  const columns = [
    { key: 'partner', content: t('Partner'), textPosition: 'left' },
    { key: 'class', content: t('Class'), textPosition: 'left' },
    { key: 'price', content: t('Price'), textPosition: 'right' },
    { key: 'from', content: t('From'), textPosition: 'right' },
    { key: 'to', content: t('To'), textPosition: 'right' },
    {
      key: 'action',
      content: (
        <ExpandButton
          onClick={actions.handleChangeExpandView}
          expandDirection={data.expandDirection}
        />
      ),
      textPosition: 'right',
    },
  ] as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default DefaultTableHeader;
